import { Comp_page1_1 } from '../components';
import React,{useState,useEffect} from "react";
// Auto-generated page



export default function Page1(props) {
return (
    <div>
      {/* Buraya componentler eklenir */}
          <Comp_page1_1 />
    </div>
  )
}
